import self from '@/common/utils/global-config';
import * as Constants from '@/common/utils/constants';

/*
* enabled[string]：是否在顶部功能栏展示
* */
export function belongConfig(id) {
  let belong = {};
  if (!self.$sn.validate.empty(id)) {
    const BelongCompare = {
      [Constants.HOSPITAL_ID_SDSL]: {
        'TJYY': {
          'title': '体检预约',
          'assembly': '体检预约',
          'sub': 'Medical Reservation',
          'enabled': '1',
          'sort': 11,
          'compare': {
            // 批量与团约
            [Constants.FUNCTION_ID_PLYTY]: {}
          }
        },
        'ZHCX': {
          'title': '综合查询',
          'assembly': '',
          'sub': '',
          'enabled': '1',
          'sort': 12,
          'compare': {
            // 门诊报告
            [Constants.FUNCTION_ID_MZBG]: {},
            // 门诊费用
            [Constants.FUNCTION_ID_MZFY]: {},
            // 处方信息
            [Constants.FUNCTION_ID_CFXX]: {},
            // 药品说明书
            [Constants.FUNCTION_ID_YPSMS]: {}
          }
        },
        'BLXZ': {
          'title': '病历下载',
          'assembly': '',
          'sub': '',
          'enabled': '1',
          'sort': 13,
          'compare': {
            ['other' + 'f954c72b' + Constants.HOSPITAL_ID_SDSL]: {
              'alias': '病历下载',
              'url': 'https://www.telemedicine.net.cn:6443/phr/share/index.do',
              'sort': 0,
              'remark': '',
              'params': ''
            }
          }
        },
        'FYCX': {
          'enabled': '0'
        },
        'BGCX': {
          'enabled': '0'
        },
        'CFCX': {
          'enabled': '0'
        },
        'YPSMS': {
          'enabled': '0'
        },
        'ZXCZ': {
          'title': '挂号费预存',
          'assembly': '挂号费预存',
          'sub': ''
        },
        'CJWT': {
          'title': '常见问题',
          'assembly': '',
          'sub': '',
          'enabled': '1',
          'sort': 131,
          'compare': {
            ['other' + '51381ba1' + Constants.HOSPITAL_ID_SDSL]: {
              'alias': '常见问题',
              'url': 'http://www.sph.com.cn/Html/News/Main/156.html',
              'sort': 0,
              'remark': '',
              'params': ''
            }
          }
        },
        'JKJT': {
          'compare': {
            ['other' + 'fd38f310' + Constants.HOSPITAL_ID_SDSL]: {
              'alias': '疾病百科',
              'url': 'https://zlwyl.iflyhealth.com/aiGuide-jbbk/?channel=sdslyy190#/',
              'sort': 1,
              'remark': '',
              'params': ''
            }
          }
        },
        'WJTC': {
          'title': '问卷调查',
          'assembly': '问卷调查',
          'sub': 'Questionnaire Survey',
          'enabled': '1',
          'sort': 141,
          'compare': {
            // 门诊满意度调查
            [Constants.FUNCTION_ID_MZMYDDC]: {
              'url': '/other/multi-patient/out-questionnaire',
              'sort': 0,
              'remark': '',
              'params': ''
            },
            // 投诉与建议
            [Constants.FUNCTION_ID_TSYJY]: {
              'url': '/other/multi-patient/complaint-suggest',
              'sort': 1,
              'remark': '',
              'params': ''
            },
            // 住院满意度调查
            [Constants.FUNCTION_ID_ZYMYDDC]: {
              'url': '/other/multi-patient/in-questionnaire',
              'sort': 2,
              'remark': '',
              'params': ''
            }
          }
        }
      },
      [Constants.HOSPITAL_ID_LCRM]: {
        'ZHCX': {
          'title': '综合查询',
          'assembly': '',
          'sub': '',
          'enabled': '1',
          'sort': 11,
          'compare': {
            // 门诊报告
            [Constants.FUNCTION_ID_MZBG]: {},
            // 门诊费用
            [Constants.FUNCTION_ID_MZFY]: {},
            // 处方信息
            [Constants.FUNCTION_ID_CFXX]: {},
            // 门诊云胶片
            [Constants.FUNCTION_ID_MZYJP]: {},
            // 病理报告
            [Constants.FUNCTION_ID_BLBG]: {},
            // 药品说明书
            [Constants.FUNCTION_ID_YPSMS]: {},
            // 住院报告
            [Constants.FUNCTION_ID_ZYBG]: {},
            // 出院带药
            [Constants.FUNCTION_ID_CYDY]: {},
            // 住院云胶片
            [Constants.FUNCTION_ID_ZYYJP]: {}
          }
        },
        'FYCX': {
          'enabled': '0'
        },
        'BGCX': {
          'enabled': '0'
        },
        'CFCX': {
          'enabled': '0'
        },
        'YPSMS': {
          'enabled': '0'
        },
        'CYDY': {
          'enabled': '0'
        },
        'WJTC': {
          'title': '问卷调查',
          'assembly': '问卷调查',
          'sub': 'Questionnaire Survey',
          'enabled': '1',
          'sort': 141,
          'compare': {
            // 门诊满意度调查
            [Constants.FUNCTION_ID_MZMYDDC]: {
              'url': '/other/multi-patient/out-questionnaire',
              'sort': 0,
              'remark': '',
              'params': ''
            },
            // 住院满意度调查
            [Constants.FUNCTION_ID_ZYMYDDC]: {
              'url': '/other/multi-patient/in-questionnaire',
              'sort': 1,
              'remark': '',
              'params': ''
            },
            // 投诉与建议
            [Constants.FUNCTION_ID_TSYJY]: {
              'url': '/other/multi-patient/complaint-suggest',
              'sort': 2,
              'remark': '',
              'params': ''
            }
          }
        }
      },
      [Constants.HOSPITAL_ID_JNYZ]: {
        'ZHCX': {
          'title': '综合查询',
          'assembly': '',
          'sub': '',
          'enabled': '1',
          'sort': 11,
          'compare': {
            // 门诊报告
            [Constants.FUNCTION_ID_MZBG]: {},
            // 处方信息
            [Constants.FUNCTION_ID_CFXX]: {},
            // 门诊费用
            [Constants.FUNCTION_ID_MZFY]: {},
            // 药品说明书
            [Constants.FUNCTION_ID_YPSMS]: {},
            ['other' + '39064803' + Constants.HOSPITAL_ID_JNYZ]: {
              'alias': '体检报告',
              'url': 'https://www.mytijian.com/m/jnsdsrmyy/myreport',
              'sort': 0,
              'remark': '',
              'params': ''
            },
            // 住院费用
            [Constants.FUNCTION_ID_ZYFY]: {},
            // 住院日清单
            [Constants.FUNCTION_ID_ZYRQD]: {},
            // 住院报告
            [Constants.FUNCTION_ID_ZYBG]: {},
            // 出院带药
            [Constants.FUNCTION_ID_CYDY]: {}
          }
        },
        'FYCX': {
          'enabled': '0'
        },
        'BGCX': {
          'enabled': '0'
        },
        'CFCX': {
          'enabled': '0'
        },
        'YPSMS': {
          'enabled': '0'
        },
        'CYDY': {
          'enabled': '0'
        },
        'WJTC': {
          'title': '满意度调查',
          'assembly': '满意度调查',
          'sub': 'Questionnaire Survey',
          'enabled': '1',
          'sort': 141,
          'compare': {
            // 门诊满意度调查
            [Constants.FUNCTION_ID_MZMYDDC]: {
              'url': 'https://www.yzph.org:6789/s/DZUd1JgD?ext=pc',
              'sort': 0,
              'remark': '',
              'params': ''
            },
            // 住院满意度调查
            [Constants.FUNCTION_ID_ZYMYDDC]: {
              'url': 'https://www.yzph.org:6789/s/fg8ioEYb?ext=pc',
              'sort': 1,
              'remark': '',
              'params': ''
            }
          }
        }
      }
    };
    belong = BelongCompare[self.$sn.utils.getHospitalId()];
  }
  else {
    belong = {
      'GHYY': {
        'title': '预约挂号',
        'assembly': '',
        'sub': '',
        'enabled': '1',
        'sort': 10,
        'compare': {
          // 预约挂号
          [Constants.FUNCTION_ID_GHYY]: {}
        }
      },
      'FYCX': {
        'title': '费用查询',
        'assembly': '费用查询',
        'sub': 'Fee Inquiry',
        'enabled': '1',
        'sort': 20,
        'compare': {
          // 门诊费用
          [Constants.FUNCTION_ID_MZFY]: {},
          // 住院费用
          [Constants.FUNCTION_ID_ZYFY]: {},
          // 住院日清单
          [Constants.FUNCTION_ID_ZYRQD]: {}
        }
      },
      'BGCX': {
        'title': '报告查询',
        'assembly': '在线查询',
        'sub': 'Report Inquiry',
        'enabled': '1',
        'sort': 30,
        'compare': {
          // 门诊报告
          [Constants.FUNCTION_ID_MZBG]: {},
          // 门诊云胶片
          [Constants.FUNCTION_ID_MZYJP]: {},
          // 病理报告
          [Constants.FUNCTION_ID_BLBG]: {},
          // 住院报告
          [Constants.FUNCTION_ID_ZYBG]: {},
          // 住院云胶片
          [Constants.FUNCTION_ID_ZYYJP]: {},
          // 体检报告
          [Constants.FUNCTION_ID_TJBG]: {}
        }
      },
      'CFCX': {
        'title': '处方查询',
        'assembly': '处方查询',
        'sub': 'Prescription Inquiry',
        'enabled': '1',
        'sort': 40,
        'compare': {
          // 处方信息
          [Constants.FUNCTION_ID_CFXX]: {}
        }
      },
      'YPSMS': {
        'title': '药品说明书',
        'assembly': '药品说明书',
        'sub': 'Drug Instructions',
        'enabled': '1',
        'sort': 50,
        'compare': {
          // 药品说明书
          [Constants.FUNCTION_ID_YPSMS]: {}
        }
      },
      'CYDY': {
        'title': '出院带药',
        'assembly': '出院带药',
        'sub': '',
        'enabled': '1',
        'sort': 60,
        'compare': {
          // 出院带药
          [Constants.FUNCTION_ID_CYDY]: {}
        }
      },
      'WJCX': {
        'title': '物价查询',
        'assembly': '物价查询',
        'sub': '',
        'enabled': '1',
        'sort': 70,
        'compare': {
          // 物价查询
          [Constants.FUNCTION_ID_WJCX]: {}
        }
      },
      'ZXCZ': {
        'title': '门诊充值',
        'assembly': '门诊充值',
        'sub': 'Outpatient Recharge',
        'enabled': '1',
        'sort': 80,
        'compare': {
          // 门诊充值
          [Constants.FUNCTION_ID_MZCZ]: {},
          // 住院充值
          [Constants.FUNCTION_ID_ZYCZ]: {}
        }
      },
      'MZJF': {
        'title': '自助缴费',
        'assembly': '自助缴费',
        'sub': '',
        'enabled': '1',
        'sort': 90,
        'compare': {
          // 门诊缴费
          [Constants.FUNCTION_ID_MZJF]: {}
        }
      },
      'YJYY': {
        'title': '医技预约',
        'assembly': '医技预约',
        'sub': '',
        'enabled': '1',
        'sort': 100,
        'compare': {
          // 医技预约
          [Constants.FUNCTION_ID_YJYY]: {}
        }
      },
      'BLYJ': {
        'title': '病历邮寄',
        'assembly': '病历邮寄',
        'sub': '',
        'enabled': '1',
        'sort': 110,
        'compare': {
          // 住院病历邮寄
          [Constants.FUNCTION_ID_ZYBLYJ]: {}
        }
      },
      'YYJL': {
        'title': '预约记录',
        'assembly': '预约记录',
        'sub': 'Reservation Record',
        'enabled': '1',
        'sort': 120,
        'compare': {
          // 预约挂号
          [Constants.FUNCTION_ID_GHYY]: {
            mode: 'record'
          },
          // 多学科综合门诊
          [Constants.FUNCTION_ID_DXKZHMZ]: {
            mode: 'record'
          },
          // 医技预约
          [Constants.FUNCTION_ID_YJYY]: {
            mode: 'record'
          },
          // 住院病历邮寄
          [Constants.FUNCTION_ID_ZYBLYJ]: {
            mode: 'record'
          }
        }
      },
      'JZRGL': {
        'title': '就诊人管理',
        'assembly': '就诊人',
        'sub': 'Patient Manage',
        'enabled': '1',
        'sort': 130,
        'compare': {
          // 就诊人管理
          ['ordinary' + 'a2eb3fad']: {
            'alias': '就诊人'
          }
        }
      },
      'JKJT': {
        'title': '健康讲堂',
        'assembly': '健康讲堂',
        'sub': 'Health Lecture',
        'enabled': '1',
        'sort': 140,
        'compare': {
          // 专家讲堂
          [Constants.FUNCTION_ID_ZJJT]: {}
        }
      },
      'JYZN': {
        'title': '就医指南',
        'assembly': '就医指南',
        'sub': '',
        'enabled': '1',
        'sort': 150,
        'compare': {
          // 就医指南
          [Constants.FUNCTION_ID_JYZN]: {}
        }
      },
      'GRZX': {
        'title': '',
        'assembly': '个人中心',
        'sub': 'Personal Center',
        'enabled': '0',
        'sort': 0,
        'compare': {
          // 修改密码
          ['ordinary' + 'e1f127f0']: {
            'alias': '修改密码'
          }
        }
      }
    };
  }
  return belong;
}

export function orderConfig() {
  return [{
    // 预约挂号
    id: Constants.FUNCTION_ID_GHYY,
    alias: '挂号预约记录',
    url: '/appointment/record',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 多学科综合门诊
    id: Constants.FUNCTION_ID_DXKZHMZ,
    alias: '多学科会诊记录',
    url: '/appointment/multiple/record',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 医技预约
    id: Constants.FUNCTION_ID_YJYY,
    url: '/mta/homepage/record',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 住院病历邮寄
    id: Constants.FUNCTION_ID_ZYBLYJ,
    // TODO
    url: '',
    sort: 0,
    remark: '',
    params: ''
  }];
}

export function gatherConfig() {
  return [{
    // 预约挂号
    id: Constants.FUNCTION_ID_GHYY,
    url: self.$sn.getConfig('pcEntranceArea') ? '/appointment/area' : '/appointment/depart',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 门诊充值
    id: Constants.FUNCTION_ID_MZCZ,
    url: '/recharge/out/homepage/recharge',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 门诊费用
    id: Constants.FUNCTION_ID_MZFY,
    url: '/query/payment',
    sort: 0,
    remark: '',
    params: {
      type: '1'
    }
  }, {
    // 门诊报告
    id: Constants.FUNCTION_ID_MZBG,
    url: '/query/report',
    sort: 0,
    remark: '',
    params: {
      type: '1'
    }
  }, {
    // 处方信息,
    id: Constants.FUNCTION_ID_CFXX,
    url: '/query/prescription',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 药品说明书
    id: Constants.FUNCTION_ID_YPSMS,
    url: '/other/instructions',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 门诊云胶片
    id: Constants.FUNCTION_ID_MZYJP,
    url: '/query/cloud-film',
    sort: 0,
    remark: '',
    params: {
      type: '1'
    }
  }, {
    // 病理报告
    id: Constants.FUNCTION_ID_BLBG,
    url: '/query/pathology',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 门诊缴费
    id: Constants.FUNCTION_ID_MZJF,
    url: '/homepage/payment',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 医技预约
    id: Constants.FUNCTION_ID_YJYY,
    url: '/mta/homepage/ap',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 住院充值
    id: Constants.FUNCTION_ID_ZYCZ,
    url: '/recharge/in/homepage/recharge',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 住院费用
    id: Constants.FUNCTION_ID_ZYFY,
    url: '/query/payment',
    sort: 0,
    remark: '',
    params: {
      type: '2'
    }
  }, {
    // 住院报告
    id: Constants.FUNCTION_ID_ZYBG,
    url: '/query/report',
    sort: 0,
    remark: '',
    params: {
      type: '2'
    }
  }, {
    // 住院云胶片
    id: Constants.FUNCTION_ID_ZYYJP,
    url: '/query/cloud-film',
    sort: 0,
    remark: '',
    params: {
      type: '2'
    }
  }, {
    // 出院带药
    id: Constants.FUNCTION_ID_CYDY,
    url: '/query/discharge-medicine',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 住院日清单
    id: Constants.FUNCTION_ID_ZYRQD,
    url: '/query/payment-day',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 住院病历邮寄
    id: Constants.FUNCTION_ID_ZYBLYJ,
    // TODO
    url: '',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 批量与团约
    id: Constants.FUNCTION_ID_PLYTY,
    url: '/physical/group-register',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 体检报告
    id: Constants.FUNCTION_ID_TJBG,
    url: '/physical/report',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 就医指南
    id: Constants.FUNCTION_ID_JYZN,
    url: '/other/medical-guide',
    sort: 0,
    remark: '',
    params: self.$sn.getConfig('functionMedicalGuideParams')
  }, {
    // 专家讲堂
    id: Constants.FUNCTION_ID_ZJJT,
    url: '/lecture/homepage',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 物价查询
    id: Constants.FUNCTION_ID_WJCX,
    url: '/query/price',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 就诊人管理
    id: 'ordinary' + 'a2eb3fad',
    url: '/patient/out/homepage',
    sort: 0,
    remark: '',
    params: ''
  }, {
    // 修改密码
    id: 'ordinary' + 'e1f127f0',
    url: '/login/register',
    sort: 0,
    remark: '',
    params: {
      mode: '3'
    }
  }];
}

// 预约业务类型功能区配置
export function businessConfig() {
  return [{
    title: '高端医学部<span class="sn-fc-main">（VIP门诊）</span>',
    caption: self.$sn.getConfig('costContentTitle') + '<span class="sn-fc-red1">300</span>元',
    image: '/hos/ui/images/high-end-medical-department.png',
    url: '',
    sort: 0,
    type: Constants.BASIC_BUSINESS_OFFLINE_GDYXB,
    remark: '',
    params: ''
  }, {
    title: self.$sn.getConfig('entireDoctorFunctionTitle'),
    caption: '全部坐诊医生',
    image: '/hos/ui/images/all-doctor.png',
    url: '',
    sort: 1,
    type: Constants.BASIC_BUSINESS_OFFLINE_CKQBYS,
    remark: '',
    params: ''
  }, {
    title: self.$sn.getConfig('famousExpertFunctionTitle'),
    caption: self.$sn.getConfig('isShowCostContent') ? self.$sn.getConfig('costContentTitle') + '<span class="sn-fc-red1">' + self.$sn.getConfig('famousExpertCost') + '</span>元' : null,
    image: '/hos/ui/images/famous-expert.png',
    url: '',
    sort: self.$sn.getConfig('famousExpertSort'),
    type: Constants.BASIC_BUSINESS_OFFLINE_ZMZJH,
    remark: '',
    params: ''
  }, {
    title: self.$sn.getConfig('internetClinicFunctionTitle'),
    caption: self.$sn.getConfig('internetClinicFunctionTextContent'),
    image: '/hos/ui/images/international-clinic.png',
    url: '',
    sort: 3,
    type: Constants.BASIC_BUSINESS_OFFLINE_GJTXMZ,
    remark: '',
    params: ''
  }, {
    title: '专家号',
    caption: self.$sn.getConfig('isShowCostContent') ? self.$sn.getConfig('costContentTitle') + '<span class="sn-fc-red1">' + self.$sn.getConfig('expertCost') + '</span>元' : null,
    image: '/hos/ui/images/expert.png',
    url: '',
    sort: 4,
    type: Constants.BASIC_BUSINESS_OFFLINE_ZJH,
    remark: '',
    params: ''
  }, {
    title: '急诊号',
    caption: self.$sn.getConfig('isShowCostContent') ? self.$sn.getConfig('costContentTitle') + '<span class="sn-fc-red1">' + self.$sn.getConfig('emergencyCost') + '</span>元' : null,
    image: '/hos/ui/images/emergency.png',
    url: '',
    sort: 5,
    type: Constants.BASIC_BUSINESS_OFFLINE_JZH,
    remark: '',
    params: ''
  }, {
    title: '普通号',
    caption: self.$sn.getConfig('isShowCostContent') ? self.$sn.getConfig('costContentTitle') + '<span class="sn-fc-red1">' + self.$sn.getConfig('ordinaryCost') + '</span>元' : null,
    image: '/hos/ui/images/ordinary.png',
    url: '',
    sort: 6,
    type: Constants.BASIC_BUSINESS_OFFLINE_PTH,
    remark: '',
    params: ''
  }, {
    title: '便民号',
    caption: self.$sn.getConfig('isShowCostContent') ? self.$sn.getConfig('costContentTitle') + '<span class="sn-fc-red1">' + self.$sn.getConfig('convenientCost') + '</span>元' : null,
    image: '/hos/ui/images/convenient.png',
    url: '',
    sort: 7,
    type: Constants.BASIC_BUSINESS_OFFLINE_BMH,
    remark: '',
    params: ''
  }, {
    title: '特色专病门诊',
    caption: self.$sn.getConfig('isShowCostContent') ? self.$sn.getConfig('costContentTitle') + '<span class="sn-fc-red1">8-300</span>元' : null,
    image: '/hos/ui/images/feature-clinic.png',
    url: '',
    sort: 8,
    type: Constants.BASIC_BUSINESS_OFFLINE_TSMZ,
    remark: '',
    params: ''
  }, {
    title: '省府门诊（中医科、推拿科）',
    caption: '济南市历下区省府前街15号',
    image: '',
    url: '',
    sort: 10,
    type: Constants.BASIC_BUSINESS_OFFLINE_ZFMZ,
    remark: '',
    params: ''
  }, {
    title: '肺结节多学科综合门诊',
    caption: '查看详细内容',
    image: '/hos/ui/images/pulmonary-nodule-multiple.png',
    url: '',
    sort: 11,
    type: Constants.BASIC_BUSINESS_OFFLINE_FJJDXKZHMZ,
    remark: '',
    params: ''
  }, {
    title: '消化肿瘤多学科综合门诊',
    caption: '查看详细内容',
    image: '/hos/ui/images/digestive-tumor-multiple.png',
    url: '',
    sort: 12,
    type: Constants.BASIC_BUSINESS_OFFLINE_XHZLDXKZHMZ,
    remark: '',
    params: ''
  }, {
    title: self.$sn.getConfig('specialDiseaseClinicTitle'),
    caption: self.$sn.getConfig('specialDiseaseClinicTextContent'),
    image: '',
    url: '',
    sort: 13,
    type: Constants.BASIC_BUSINESS_OFFLINE_ZBMZ,
    remark: '',
    params: ''
  }, {
    title: '省委门诊（口腔科、推拿科）',
    caption: '济南市市中区纬一路480-1号',
    image: '',
    url: '/sub-pages/appointment/select-depart',
    sort: 14,
    type: Constants.BASIC_BUSINESS_OFFLINE_SWMZ,
    remark: '',
    params: ''
  }, {
    title: self.$sn.utils.getFunctionTitle('0', Constants.FUNCTION_ID_DXKZHMZ),
    caption: self.$sn.utils.getFunctionTitle('1', Constants.FUNCTION_ID_DXKZHMZ),
    image: '/hos/ui/images/multiple-clinic.png',
    url: self.$sn.getConfig('functionMultipleClinicUrl'),
    sort: self.$sn.getConfig('multipleClinicFunctionSort'),
    type: Constants.BASIC_BUSINESS_OFFLINE_DXKZHMZ,
    remark: 'feature',
    params: ''
  }, {
    title: '综合治疗门诊',
    caption: '诊疗门诊',
    image: '/hos/ui/images/cosmetology-clinic.png',
    url: '',
    sort: 18,
    type: Constants.BASIC_BUSINESS_OFFLINE_ZLYY,
    remark: 'feature',
    params: ''
  }, {
    title: '山东省医学影像学研究所（医学影像会诊门诊）',
    caption: '',
    image: '',
    url: '',
    sort: 19,
    type: Constants.BASIC_BUSINESS_OFFLINE_YXMZ,
    remark: '',
    params: ''
  }, {
    title: '疑难罕见病门诊',
    caption: '罕见病的深入诊治',
    image: '/hos/ui/images/rare-disease-clinic.png',
    url: '',
    sort: 20,
    type: Constants.BASIC_BUSINESS_OFFLINE_YNHJBMZ,
    remark: 'feature',
    params: ''
  }, {
    title: '联合门诊',
    caption: '两个学科专家联合诊疗',
    image: '/hos/ui/images/combined-clinic.png',
    url: '',
    sort: 21,
    type: Constants.BASIC_BUSINESS_OFFLINE_LHMZ,
    remark: 'feature',
    params: ''
  }, {
    title: self.$sn.getConfig('teamClinicFunctionTitle'),
    caption: self.$sn.getConfig('teamClinicFunctionTextContent'),
    image: '/hos/ui/images/team-clinic.png',
    url: '',
    sort: 22,
    type: Constants.BASIC_BUSINESS_OFFLINE_ZJTDYY,
    remark: 'feature',
    params: ''
  }, {
    title: '专科联盟就诊预约',
    caption: '',
    image: '/hos/ui/images/consortium-clinic.png',
    url: '',
    sort: 23,
    type: Constants.BASIC_BUSINESS_OFFLINE_ZKLMJZYY,
    remark: 'feature',
    params: ''
  }, {
    title: '睡眠疾病团队',
    caption: '睡眠疾病团队',
    image: '/hos/ui/images/sleep-clinic.png',
    url: '',
    sort: 24,
    type: Constants.BASIC_BUSINESS_OFFLINE_SMJBTD,
    remark: 'feature',
    params: ''
  }, {
    title: '暑期门诊预约',
    caption: '暑期门诊预约',
    image: '',
    url: '',
    sort: 25,
    type: Constants.BASIC_BUSINESS_OFFLINE_SQMZYY,
    remark: '',
    params: ''
  }];
}
